import { render, staticRenderFns } from "./StandardLogin.vue?vue&type=template&id=579b7a12&scoped=true&"
import script from "./StandardLogin.vue?vue&type=script&lang=js&"
export * from "./StandardLogin.vue?vue&type=script&lang=js&"
import style0 from "./StandardLogin.vue?vue&type=style&index=0&id=579b7a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b7a12",
  null
  
)

export default component.exports